import React from 'react';
import { useNavigate } from 'react-router-dom';

const styles = {
  card: {
    backgroundColor: '#FFFFFF',
    borderRadius: '16px',
    overflow: 'hidden',
    marginBottom: '0',
    boxShadow: '0 2px 12px rgba(240,90,53,0.1)',
    border: 'none',
    cursor: 'pointer',
    opacity: 1,
    transition: 'opacity 0.2s ease',
  },
  archivedCard: {
    opacity: 0.5,
  },
  image: {
    width: '100%',
    height: '160px',
    objectFit: 'cover',
    backgroundColor: 'var(--tg-theme-secondary-bg-color, #f0f0f0)',
  },
  imagePlaceholder: {
    width: '100%',
    height: '80px',
    backgroundColor: 'var(--tg-theme-secondary-bg-color, #f0f0f0)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '32px',
  },
  body: {
    padding: '12px',
  },
  title: {
    fontSize: '15px',
    fontWeight: '600',
    color: 'var(--tg-theme-text-color, #000)',
    marginBottom: '4px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  description: {
    fontSize: '13px',
    color: 'var(--tg-theme-hint-color, #8e8e93)',
    marginBottom: '8px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
  url: {
    fontSize: '12px',
    color: 'var(--tg-theme-link-color, #007aff)',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    marginBottom: '8px',
  },
  footer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    gap: '6px',
  },
  tags: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '4px',
  },
  tag: {
    backgroundColor: 'var(--tg-theme-secondary-bg-color, #f0f0f0)',
    borderRadius: '6px',
    padding: '2px 6px',
    fontSize: '11px',
    color: '#2D2424',
  },
  marks: {
    display: 'flex',
    gap: '4px',
  },
  mark: {
    fontSize: '16px',
  },
  indicators: {
    display: 'flex',
    gap: '6px',
    fontSize: '12px',
    color: 'var(--tg-theme-hint-color, #8e8e93)',
  },
  archiveBtn: {
    background: 'none',
    border: '1px solid var(--tg-theme-hint-color, #ccc)',
    borderRadius: '6px',
    padding: '4px 8px',
    fontSize: '12px',
    cursor: 'pointer',
    color: 'var(--tg-theme-hint-color, #8e8e93)',
  },
};

export default function ItemCard({ item, onArchive, onUnarchive, listId, categoryId, canEdit = false }) {
  const navigate = useNavigate();

  const handleClick = () => {
    const params = new URLSearchParams();
    if (listId) params.set('list_id', listId);
    if (categoryId) params.set('category_id', categoryId);
    navigate(`/items/${item.id}?${params.toString()}`);
  };

  const handleArchiveClick = (e) => {
    e.stopPropagation();
    if (item.is_archived) {
      onUnarchive?.(item.id);
    } else {
      onArchive?.(item.id);
    }
  };

  const tags = Array.isArray(item.tags) ? item.tags.filter(Boolean) : [];
  const marks = Array.isArray(item.marks) ? item.marks.filter(Boolean) : [];

  const hostname = (() => {
    try {
      return new URL(item.url).hostname.replace(/^www\./, '');
    } catch {
      return item.url;
    }
  })();

  return (
    <div
      style={{ ...styles.card, ...(item.is_archived ? styles.archivedCard : {}) }}
      onClick={handleClick}
    >
      {item.image_url && (
        <img
          src={item.image_url}
          alt={item.title || 'Изображение'}
          style={styles.image}
          onError={(e) => {
            e.target.style.display = 'none';
          }}
        />
      )}

      <div style={styles.body}>
        <div style={styles.title}>{item.title || hostname}</div>

        {item.description && (
          <div style={styles.description}>{item.description}</div>
        )}

        {item.url && <div style={styles.url}>{hostname}</div>}
        {item.price && <div style={{ fontSize: '14px', fontWeight: '700', color: '#F05A35', marginBottom: '8px' }}>{item.price}</div>}

        {item.notes && (
          <div style={{ ...styles.description, fontStyle: 'italic' }}>
            📝 {item.notes}
          </div>
        )}

        <div style={styles.footer}>
          <div style={styles.tags}>
            {tags.map((tag) => (
              <span key={tag.id} style={styles.tag}>
                #{tag.name}
              </span>
            ))}
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            {marks.length > 0 && (
              <div style={styles.marks}>
                {marks.map((mark) => (
                  <span key={mark.id} style={styles.mark} title={mark.mark_name}>
                    {mark.mark_emoji || '✓'}
                  </span>
                ))}
              </div>
            )}

            {canEdit && (
              <button style={styles.archiveBtn} onClick={handleArchiveClick}>
                {item.is_archived ? '↩ Восстановить' : '📦 В архив'}
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
